export default "__VITE_ASSET__adc1c10b__"